import { lazy } from 'react'

import SubscriptionVenuesLoader from './loader'

export default {
  SubscriptionVenues: {
    Component: lazy(() => import('./SubscriptionVenues.Page')),
    Loader: SubscriptionVenuesLoader,
  },
}
